module.exports = __webpack_public_path__ + "static/media/pin_hospedagens.3bce2979.png";